import { Component } from '@angular/core';

@Component({
  selector: 'app-main-penalties',
  templateUrl: './main-penalties.component.html',
  styleUrls: ['./main-penalties.component.css'],
})
export class MainPenaltiesComponent {}
